// OBT — Formen paneli (F2-B: işlevsel cevap akışı + F3-E bildirim yüzeyi)
//
// Formen paneli görev odaklıdır: kampanya oluşturma / müdür kararı / raporlama /
// kurumsal hafıza KARTLARI bulunmaz. F3-E ile yalnız kendi bildirimlerini gören
// dar bir bildirim zili eklenir (yönetim menüsü AÇILMAZ).
//
// Yeni global route KURULMAZ; ekran kendi yerel görünüm state'ini yönetir.
import { useState } from 'react';
import ForemanResponseScreen from '../response/ForemanResponseScreen';
import ObtNotificationsPanel from '../notifications/ObtNotificationsPanel';
import ObtNotificationBell from '../notifications/ObtNotificationBell';

export default function ObtForemanDashboard({ enabled = true }) {
  const [view, setView] = useState('overview');

  if (view === 'notifications') {
    return (
      <ObtNotificationsPanel
        role="foreman"
        enabled={enabled}
        onNavigate={() => setView('overview')}
        onBack={() => setView('overview')}
      />
    );
  }

  return (
    <div className="space-y-4">
      <div className="flex justify-end">
        <ObtNotificationBell
          enabled={enabled && view === 'overview'}
          onClick={() => setView('notifications')}
        />
      </div>
      <ForemanResponseScreen enabled={enabled} />
    </div>
  );
}
